import { createI18n } from "vue-i18n";

import enUS from "./en-us";
import zhCN from "./zh-cn";

const LANG = {
  EnUS: "en-us",
  ZhCn: "zh-cn",
};

// export function getBrowserLang() {
//   let browserLang = navigator.language
//     ? navigator.language
//     : (navigator as any).browserLanguage;
//   let defaultBrowserLang = "";
//   if (["cn", "zh", "zh-cn"].includes(browserLang.toLowerCase())) {
//     defaultBrowserLang = "zh-cn";
//   } else {
//     defaultBrowserLang = "en-us";
//   }
//   return defaultBrowserLang;
// }

// export function getBrowserLang() {
//   const urlParams = new URLSearchParams(window.location.search);
//   const buCode = urlParams.get("buCode");
//   return buCode === "DSDE064" ? "en-us" : "zh-cn";
// }

function getLocale() {
  const url = new URL(window.location.href);
  const capture = /^\/control\/([^/]+)/.exec(url.pathname);
  if (capture) {
    const bu = capture[1];
    if (bu === "DCTJ012" || bu === "DCSJ") return LANG.ZhCn;
  }
  return LANG.EnUS;
}

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: LANG.EnUS,
  messages: { [LANG.ZhCn]: zhCN, [LANG.EnUS]: enUS },
});
